import React, { PureComponent } from "react";
import config from "../../config";
import EmojiConvertor from "emoji-js";

class Emoji extends PureComponent {
  state = {
    data: null
  };

  componentDidUpdate() {
    this.emojify();
  }

  componentDidMount() {
    this.emojify();
  }

  emojify() {
    const emoji = new EmojiConvertor();
    emoji.allow_native = this.props.allowNative ? true : false;
    emoji.img_sets.emojione.path = `${
      config.EMOJI_URL
    }/emoji-data/img-emojione-64/`;
    emoji.img_sets.apple.path = `${config.EMOJI_URL}/emoji-data/img-apple-64/`;
    emoji.img_sets.google.path = `${
      config.EMOJI_URL
    }/emoji-data/img-google-64/`;

    this.setState({ data: emoji.replace_colons(`${this.props.children}`) });
  }

  createEmoji() {
    return { __html: this.state.data };
  }

  render() {
    return (
      <div
        style={{ display: "inline-block", marginBottom: "-4px" }}
        className={this.props.className}
        dangerouslySetInnerHTML={this.createEmoji()}
      />
    );
  }
}

export default Emoji;



// WEBPACK FOOTER //
// ./src/components/Emoji/Emoji.js